import { useState } from "react";

export default function ScanDocument() {
    const [loading, setLoading] = useState(true);
    return (
        <div style={{ position: "relative", height: "100vh" }}>
            {loading && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 20,
                    }}
                >
                    <div className="loader" style={{ color: "black", fontSize: 22, fontWeight: "600" }}>Loading...</div>
                </div>
            )}
            <iframe
                src="https://genai.test-uat.com" style={{ width: "100%", height: "100vh", border: "none" }}
                onLoad={() => setLoading(false)}

                title="iframe"
            />
        </div>
    );
}

